export const FirebaseConfig = {
	"projectId": "gobe-taxi",
	"appId": "1:52901823741:web:a2e697ea2b439dba502a94",
	"databaseURL": "https://gobe-taxi-default-rtdb.firebaseio.com",
	"storageBucket": "gobe-taxi.firebasestorage.app",
	"apiKey": "AIzaSyCM4fsIpTXjdUTZEJvJAqDLijuYl0vTcKY",
	"authDomain": "gobe-taxi.firebaseapp.com",
	"messagingSenderId": "52901823741",
	"measurementId": "G-Z2QBGZSHTX",
	"projectNumber": "52901823741",
	"version": "2"
};